import {abortValueIndication} from "./valueIndicationThunk";

/**
 * Ausgang einer Indikations-Anfrage, siehe `queryValueIndicationAsync`.
 *
 * - `done` — Antwort ist im Store gelandet
 * - `aborted` — von einer neueren Anfrage oder einem Bewertungs-/Adresswechsel abgebrochen (#19374)
 * - `skipped` — gar nicht gesendet (readOnly, kein Payload, fehlende Berechtigung)
 * - `error` — Validierungs- oder Query-Fehler, im Store als Fehler hinterlegt
 */
export type IndicationRequestResult = "done" | "aborted" | "skipped" | "error";

/**
 * Bricht eine noch laufende Indikations-Anfrage ab (#19374).
 *
 * Aufzurufen überall dort, wo der Bezug einer laufenden Anfrage wegfällt: beim Laden einer anderen
 * Bewertung oder eines Snapshots, beim Adresswechsel und beim Zurücksetzen der Objektparameter.
 * Ohne das kann die späte Antwort der vorigen Bewertung per `setIndicationData` noch in der Anzeige
 * landen — eingefroren wird sie nie (der Finalize-Guard erkennt den fremden Request), es ist ein
 * reiner Anzeigefehler im Zeitfenster einer AVM-Antwort.
 */
export const abortRunningIndications = (): void => {
    abortValueIndication();
};
